export default __webpack_public_path__ + "static/media/TitlePicturePlaceholder.7f9b74f5.jpg";